<template>
  <div class="app-messaging-container">
    <messenger
      ref="messenger"
      :conversations="conversations"
      :active-request="activeRequest"
      :collapsed="collapsed"
      :conversation-id="conversationId"
      :messages="messages"
      :title="title"
      v-model="text"
      v-on:open="openMessage"
      v-on:collapse="collapse"
      v-on:updateconversation="showMessage"
      v-on:read-updated="handleReadUpdated"
    >
      <template slot="title">
        {{ title }}
        <button type="button" class="btn btn-xs btn-primary right" v-on:click="openOrder">{{ $t('Orders.openOrder') }}</button>
      </template>
    </messenger>
  </div>
</template>
<script>
import Messenger from '../Elements/Messenger.vue';

var view = require('../view.js'),
    viewData = {
      conversations: [],
      collapsed: true,
      conversationId: null,
      messages: [],
      title: '',
      text: '',
      activeRequest: false
    };

export default view(viewData, {
  components: {
    'Messenger': Messenger
  },
  mounted() {
    this.$parent.viewTitle = this.$t('Messages.title');
    this.$parent.fullView = true;
    this.reset();
  },
  methods: {
    reset() {
      this.$http.get(this.$root.url + 'message/').then(
        function(res) {
          viewData.conversations = res.data.result;
          this.openMessage((viewData.conversations || [])[0]);
          /*
          setTimeout(function() {
            this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
          }.bind(this), 300);
          */
        }.bind(this),
        function(res) {
          console.log('Error loading messages', res);
          // this.$emit('alert', this.$t('Messages.errorCouldNotLoad'));
        }.bind(this));
    },
    collapse() {
      viewData.collapsed = true;
    },
    openMessage(message) {
      if (message) {
        viewData.conversationId = message.orderId;
        viewData.title = message.transactionnum;
        viewData.collapsed = false;
        this.$refs.messenger.loadConversation(message.orderId);

        this.$forceUpdate();
      }
    },
    showMessage(messages) {
      viewData.messages = messages;
    },
    openOrder() {
      this.$parent.openView('OrderDetails', this.conversationId);
    },
    handleReadUpdated(id) {
      viewData.conversations.forEach(x => {
        if (x.orderId === id) {
          x.read = x.counter;
        }
      });

      this.$parent.resetMessagesCounter();

      this.$forceUpdate()
    }
  }
});
</script>
